var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"div-oftaHistory"},[_c('br'),_c('Title2',{attrs:{"title":"HISTORIAL GENERAL DEL PACIENTE","label":"Datos generales del paciente"}}),_c('h3',[_vm._v(_vm._s(this.idApointment))]),_c('history')],1)}
var staticRenderFns = []

export { render, staticRenderFns }